import React, { useEffect } from 'react';

type useFocusElementProps<T extends HTMLObjectElement> = {
  ref: React.RefObject<T>;
  focused: boolean;
  onClick?: () => void;
  keyCode: number;
  propagate?: boolean;
};

export const useFocusElement = <T extends HTMLObjectElement>({
  ref,
  focused,
  onClick,
  keyCode,
  propagate = true,
}: useFocusElementProps<T>) => {
  useEffect(() => {
    const keyboardHandler = (e: KeyboardEvent) => {
      if (e.keyCode === keyCode && focused && onClick) {
        if (!propagate) {
          e.stopPropagation();
          e.preventDefault();
        }
        onClick();
      }
    };

    const current = ref.current;
    if (current) {
      current.addEventListener('keydown', keyboardHandler);
    }

    return () => {
      if (current) {
        current.removeEventListener('keydown', keyboardHandler);
      }
    };
  }, [focused, keyCode, onClick, ref, propagate]);
};
